module.exports = "../study/imgs/maps/Kanagawa/S8/Hazard/Slopefailure/Kanagawa_Slopefailure_HadGEM2_RCP85_End.png";